import makeStyles from "@mui/styles/makeStyles";
import { BoxPanelProps } from "./BoxPanel.types";

export const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    background: theme.palette.common.white,
    [theme.breakpoints.up("md")]: {
      borderRadius: 8,
    },
  },
  actionsBottom: {
    "& $header": {
      flexDirection: "column",
    },
    "& $actions": {
      width: "100%",
      marginTop: 8,
    },
  },
  header: {
    display: "flex",
    padding: 16,
    borderBottom: `1px solid ${theme.palette.grey[200]}`,
    [theme.breakpoints.up("md")]: {
      padding: "20px 24px",
    },
  },
  headerNoBorder: {
    borderBottom: 0,
  },
  title: {
    flex: "1",
    position: "relative",
  },
  actions: {
    position: "relative",
  },
  content: (props: BoxPanelProps) => ({
    flex: props.footerAvailableHeight ? undefined : "1",
    padding: 0,
  }),
  contentCenter: {
    "& > *": {
      display: "flex",
      alignItems: "center",
    },
  },
  contentWithPadding: {
    padding: "12px 16px 16px 16px !important",
    [theme.breakpoints.up("lg")]: {
      padding: "12px 24px 24px 24px !important",
    },
  },
  footer: (props: BoxPanelProps) => ({
    flex: props.footerAvailableHeight ? "1" : undefined,
    padding: "16px 20px 24px 20px",
    borderBottomLeftRadius: 10,
    borderBottomRightRadius: 10,
    [theme.breakpoints.up("lg")]: {
      padding: "16px 28px 24px 28px",
    },
  }),
  footerBorder: {
    "& $footer": {
      borderTop: `1px solid ${theme.palette.grey[200]}`,
    },
  },
  footerBackground: {
    "& $footer": {
      background: theme.palette.grey[50],
    },
  },
}));
